<template>
	<div>
		
		
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
			<el-form-item label="配置名:" prop="cdesc">
				<el-input size="small" v-model="ruleForm.cdesc"></el-input>
			</el-form-item>
				
			<el-form-item label="key:" prop="ckey">
				<el-input size="small" v-model="ruleForm.ckey"></el-input>
			</el-form-item>
			
			<el-form-item label="value:" prop="cvalue">
				<el-input size="small" v-model="ruleForm.cvalue"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">确认保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				rules: {
					cdesc: [{required: true, message: '请输入配置项', trigger: 'blur'}],
					ckey: [{required: true, message: '请输入配置key', trigger: 'blur'}],
					cvalue:[{required: true, message: '请输入配置value', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '编辑中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/editConfig", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '编辑成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>